import CityPageTemplate from "../city-template/CityPageTemplate";
import { fortWayneConfig } from "./data";

export default function FortWaynePage() {
  return <CityPageTemplate config={fortWayneConfig} />;
}